/**
 * free-product.js
 *
 * Ajoute ou retire automatiquement un produit offert au panier
 * selon le montant total configuré dans les settings du thème.
 *
 * Settings requis (Personnalisation du thème > Tiroir) :
 *   - free_product_condition   : montant minimum en € (ex: 50)
 *   - free_product_variant_id  : ID de la variante Shopify à offrir
 *
 * Comportement :
 *   - Condition atteinte  + produit absent  → ajout automatique
 *   - Condition non atteinte + produit présent → suppression automatique
 *   - Le total est calculé en excluant le produit offert lui-même
 */

(function () {
  const settings = window.freeProductSettings;

  // Ne rien faire si les settings ne sont pas configurés
  if (!settings || !settings.variantId || !settings.condition) return;

  const freeVariantId = parseInt(settings.variantId, 10);
  const condition = settings.condition; // déjà en centimes (converti en Liquid)

  if (isNaN(freeVariantId) || freeVariantId <= 0) return;

  // Verrou pour éviter les boucles infinies
  let isSyncing = false;

  /**
   * Calcule le total du panier en excluant le produit offert,
   * pour ne pas fausser la condition.
   */
  function getCartTotalWithoutFreeItem(cartData) {
    return cartData.items
      .filter((item) => item.variant_id !== freeVariantId)
      .reduce((sum, item) => sum + item.final_line_price, 0);
  }

  /**
   * Retourne l'item du produit offert s'il est dans le panier.
   */
  function findFreeItem(cartData) {
    return cartData.items.find((item) => item.variant_id === freeVariantId);
  }

  /**
   * Vérifie l'état du panier et synchronise le produit offert.
   */
  function checkAndSync(cartData) {
    const total = getCartTotalWithoutFreeItem(cartData);
    const freeItem = findFreeItem(cartData);
    const conditionMet = total >= condition;

    if (conditionMet && !freeItem) {
      addFreeProduct();
    } else if (!conditionMet && freeItem) {
      removeFreeProduct(freeItem.key);
    }
  }

  /**
   * Ajoute le produit offert au panier.
   */
  function addFreeProduct() {
    isSyncing = true;

    fetch(window.routes.cart_add_url, {
      ...fetchConfig(),
      body: JSON.stringify({
        items: [{ id: freeVariantId, quantity: 1, properties: { _gift: 'true' } }],
      }),
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          console.warn('[FreeProduct] Impossible d\'ajouter le produit offert :', response.description);
          return;
        }
        refreshCart();
      })
      .catch((e) => console.error('[FreeProduct] Erreur ajout :', e))
      .finally(() => {
        isSyncing = false;
      });
  }

  /**
   * Retire le produit offert du panier.
   */
  function removeFreeProduct(itemKey) {
    isSyncing = true;

    fetch(window.routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify({ id: itemKey, quantity: 0 }),
    })
      .then((r) => r.json())
      .then(() => {
        refreshCart();
      })
      .catch((e) => console.error('[FreeProduct] Erreur suppression :', e))
      .finally(() => {
        isSyncing = false;
      });
  }

  /**
   * Récupère l'état frais du panier et publie un event cartUpdate
   * pour déclencher le re-render du tiroir / de la page panier.
   */
  function refreshCart() {
    fetch('/cart.json')
      .then((r) => r.json())
      .then((cart) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'free-product',
          cartData: cart,
        });
      })
      .catch((e) => console.error('[FreeProduct] Erreur refresh :', e));
  }

  // Écoute tous les événements de mise à jour du panier
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    // Ignorer nos propres events pour éviter la boucle infinie
    if (event.source === 'free-product') return;
    if (isSyncing) return;

    // Toujours récupérer l'état frais du panier (le cartData de l'event
    // peut être partiel selon la source : add vs change)
    fetch('/cart.json')
      .then((r) => r.json())
      .then((cart) => checkAndSync(cart))
      .catch((e) => console.error('[FreeProduct] Erreur fetch cart :', e));
  });
})();
